import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/* =======================
   Styles
======================= */
import styles from "./Pagination.module.scss";

export default function Pagination({
  currentPage,
  totalPages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) {
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleRowsPerPageChange = (e) => {
    const value = Number(e.target.value);
    onRowsPerPageChange(value);
  };

  return (
    <div className={styles["admin-pagination"]}>
      {/* ROWS PER PAGE */}
      <div className={styles["admin-pagination__page-size"]}>
        Show
        <select
          className={styles["admin-pagination__select"]}
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        per page
      </div>

      {/* CONTROLS */}
      <div className={styles["admin-pagination__controls"]}>
        <button
          className={styles["admin-pagination__btn"]}
          onClick={handlePreviousPage}
          disabled={currentPage <= 1}
          aria-label="Previous Page"
        >
          <ChevronLeft size={20} strokeWidth={2.5} />
        </button>

        <div className={styles["admin-pagination__info"]}>
          <span className={styles["admin-pagination__current"]}>
            {currentPage}
          </span>
          <span>of</span>
          <span>{totalPages}</span>
        </div>

        <button
          className={styles["admin-pagination__btn"]}
          onClick={handleNextPage}
          disabled={currentPage >= totalPages}
          aria-label="Next Page"
        >
          <ChevronRight size={20} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
